import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { RHFMultiCheckbox, RHFRadioGroup } from 'src/components/hook-form';
import ProductModifierVisual from './product-modifier-visual';

// ----------------------------------------------------------------------

ProductModifierFields.propTypes = {
  modifierGroups: PropTypes.array,
  getPrice: PropTypes.func.isRequired,
  visual: PropTypes.bool,
};

export default function ProductModifierFields({ modifierGroups, getPrice, visual = false }) {
  if (!modifierGroups?.length) {
    return null;
  }

  if (visual) {
    return <ProductModifierVisual modifierGroups={modifierGroups} getPrice={getPrice} />;
  }

  return (
    <Stack spacing={2}>
      {modifierGroups.map((mg) => {
        const options = mg.modifiers?.map((m) => ({
          ...m,
          label: `${m?.name || ''} (${getPrice(m?.actual_price || mg?.price || 0)})`,
          value: m.id,
        }));

        if (mg?.selection_allowed === 1) {
          return (
            <RHFRadioGroup
              key={mg.id}
              name={`selectedSingleModifier.mg-${mg?.id}`}
              label={`${mg?.name || ''} (Choose any ${mg?.selection_allowed})`}
              options={options}
            />
          );
        }

        return (
          <RHFMultiCheckbox
            key={mg.id}
            name="selectedModifiers"
            label={`${mg?.name || ''} (Choose any ${mg?.selection_allowed})`}
            options={options}
          />
        );
      })}
    </Stack>
  );
}
